import "@locales/i18n.ts";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://1e1f49ad0608a5e6db5b7e82e0264120@sentry.cpjcompany.com/5",
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  enabled: ["stage", "production"].includes(process.env.NODE_ENV || ""),
  environment: `job-seekers-panel-${process.env.NODE_ENV}`,
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^https:\/\/.*\.cpjcompany\.com/, /^https:\/\/.*\.cpj\.ai/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend: (event) => {
    if (!localStorage) return event;

    Object.keys(localStorage)?.forEach((key) => {
      event.extra = event.extra || {};
      event.extra[`localStorage.${key}`] = localStorage.getItem(key);
    });
    return event;
  },
});

createRoot(document.getElementById("root")!).render(<App />);
